import { useState, useCallback } from "react";
import { toast } from "react-toastify";


import { useApiariesStore } from "entities/apiaries";
import { $api } from "shared/api";
import { UnionButton } from "./styles";
import { UnionIcon } from "shared/ui/icons";

export const HiveTitleRight = () => {
    const currentApiary = useApiariesStore((s) => s.currentApiary());
    const [isLoading, setIsLoading] = useState(false);

    const handleExport = useCallback(async () => {
        if (!currentApiary?.id || isLoading) return;
        try {
            setIsLoading(true);
            const response = await $api.get(`/hives/${currentApiary.id}/hives/export`, {
                responseType: "blob",
            });

            const blob = new Blob([response.data], { type: response.headers["content-type"] ?? "text/xlsx" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const filename = `hives-${currentApiary.number ?? currentApiary.id}.xlsx`;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            const message = "Не удалось выгрузить данные улья";
            toast.error(message);
        } finally {
            setIsLoading(false);
        }
    }, [currentApiary, isLoading]);

    return (
        <UnionButton
            type="button"
            onClick={handleExport}
            disabled={!currentApiary?.id || isLoading}
        >
            <UnionIcon />
            <span>{isLoading ? "Выгрузка..." : "Выгрузить"}</span>
        </UnionButton>
    );
};

